import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
import { trackExternalLink } from '../../lib/pixel';
// TikTok icon (not in lucide-react)
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-343">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z" data-id="element-344" />
    </svg>;
}
export function Footer() {
  const {
    t,
    lang
  } = useTranslation();
  const socials = [{
    href: 'https://www.instagram.com/dtech.rs',
    icon: InstagramIcon,
    label: 'Instagram'
  }, {
    href: 'https://www.facebook.com/profile.php?id=61589561484063',
    icon: FacebookIcon,
    label: 'Facebook'
  }, {
    href: 'https://www.tiktok.com/@dtech_rs',
    icon: TikTokIcon,
    label: 'TikTok'
  }, {
    href: 'https://www.linkedin.com/company/115805045/',
    icon: LinkedinIcon,
    label: 'LinkedIn'
  }];
  return <footer className="bg-dark-surface border-t-2 border-dark-border mt-auto" data-id="element-345">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-10" data-id="element-346">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-347">
          <div data-id="element-348">
            <img src="https://cdn.magicpatterns.com/uploads/mrmC3EPvZ6yt8zBvajm1cp/LOGO_FINAL.jpg" alt="D-TECH Solutions" className="h-8 w-auto mb-4 rounded" data-id="element-349" />
            <div className="text-gray-400 text-sm leading-relaxed mb-4 space-y-1" data-id="element-350">
              <p className="font-bold text-white" data-id="element-351">DTECH ATLAS DOO</p>
              <p data-id="element-352">
                {lang === 'en' ? 'Registration No.: 22196685 | VAT No.: 115713623' : lang === 'ru' ? 'ОГРН: 22196685 | ИНН: 115713623' : 'Matični broj: 22196685 | PIB: 115713623'}
              </p>
              <div className="pt-2 mt-2 border-t border-dark-border/50" data-id="element-353">
                <p data-id="element-354">
                  Dimitrija Tucovića 42, 11050{' '}
                  {lang === 'en' ? 'Belgrade' : lang === 'ru' ? 'Белград' : 'Beograd'}
                </p>
                <p className="text-xs text-brand-yellow/80 mt-2 italic leading-relaxed" data-id="element-355">
                  {lang === 'en' ? '* The stated address represents the registered headquarters of the company. Business is conducted online, and product delivery is carried out via contracted transport and courier services.' : lang === 'ru' ? '* Указанный адрес представляет собой зарегистрированную штаб-квартиру компании. Бизнес ведется онлайн, а доставка продукции осуществляется через контрактные транспортные и курьерские службы.' : '* Navedena adresa predstavlja registrovano sedište društva. Poslovanje se obavlja online, a isporuka proizvoda vrši se putem ugovorenih transportnih i kurirskih službi.'}
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-2 mb-6 text-sm" data-id="element-356">
              <a href="mailto:info@dtech.rs" className="text-gray-400 hover:text-brand-yellow transition-colors" data-id="element-357">
                info@dtech.rs
              </a>
              <a href="tel:+381653312811" className="text-gray-400 hover:text-brand-yellow transition-colors" data-id="element-358">
                +381 65 331 2811
              </a>
            </div>
            <div data-id="element-359">
              <p className="text-white font-bold text-sm mb-3" data-id="element-360">
                {lang === 'en' ? 'Follow us' : lang === 'ru' ? 'Подписывайтесь на нас' : 'Pratite nas'}
              </p>
              <div className="flex items-center gap-3 flex-wrap" data-id="element-361">
                {socials.map(({
                href,
                icon: Icon,
                label
              }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" onClick={() => trackExternalLink(href, 'external', label)} aria-label={label} title={label} className="w-9 h-9 flex items-center justify-center rounded-industrial border border-dark-border bg-dark-bg text-gray-300 hover:text-dark-bg hover:bg-brand-yellow hover:border-brand-yellow transition-colors" data-id="element-362">
                    <Icon className="w-4 h-4" data-id="element-363" />
                  </a>)}
              </div>
            </div>
          </div>
          <div data-id="element-364">
            <h3 className="text-white font-bold mb-4" data-id="element-365">{t.footer.products}</h3>
            <ul className="space-y-2" data-id="element-366">
              <li data-id="element-367">
                <Link to="/products/sca" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-368">
                  D-TECH SCA (STANDARD)
                </Link>
              </li>
              <li data-id="element-369">
                <Link to="/products/standard" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-370">
                  D-TECH SCB (STANDARD)
                </Link>
              </li>
              <li data-id="element-371">
                <Link to="/products/standard-plus" className="text-gray-400 hover:text-white text-sm transition-colors flex items-center gap-2" data-id="element-372">
                  D-TECH SCB (STANDARD+)
                  <span className="text-[9px] font-bold uppercase tracking-wider text-brand-yellow border border-brand-yellow/50 px-1.5 py-0.5 rounded" data-id="element-373">
                    {lang === 'en' ? 'Coming soon' : lang === 'ru' ? 'Скоро' : 'Uskoro'}
                  </span>
                </Link>
              </li>
              <li data-id="element-374">
                <Link to="/products/raptor" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-375">
                  D-TECH RAPTOR (HEAVY DUTY)
                </Link>
              </li>
              <li data-id="element-376">
                <Link to="/products/scc-pro" className="text-gray-400 hover:text-white text-sm transition-colors flex items-center gap-2" data-id="element-377">
                  D-TECH SCC (PRO)
                  <span className="text-[9px] font-bold uppercase tracking-wider text-brand-yellow border border-brand-yellow/50 px-1.5 py-0.5 rounded" data-id="element-378">
                    {lang === 'en' ? 'Coming soon' : lang === 'ru' ? 'Скоро' : 'Uskoro'}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-379">
            <h3 className="text-white font-bold mb-4" data-id="element-380">{t.footer.company}</h3>
            <ul className="space-y-2" data-id="element-381">
              <li data-id="element-382">
                <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-383">
                  {t.footer.about}
                </Link>
              </li>
              <li data-id="element-384">
                <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-385">
                  {t.footer.contact}
                </Link>
              </li>
              <li data-id="element-386">
                <Link to="/politika-privatnosti" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-387">
                  {lang === 'en' ? 'Privacy Policy' : lang === 'ru' ? 'Политика конфиденциальности' : 'Politika privatnosti'}
                </Link>
              </li>
              <li data-id="element-388">
                <Link to="/uslovi-koriscenja" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-389">
                  {lang === 'en' ? 'Terms of Service' : lang === 'ru' ? 'Условия использования' : 'Uslovi korišćenja'}
                </Link>
              </li>
              <li data-id="element-390">
                <Link to="/isporuka-i-placanje" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-391">
                  {lang === 'en' ? 'Shipping & Payment' : lang === 'ru' ? 'Доставка и оплата' : 'Politika isporuke i plaćanja'}
                </Link>
              </li>
              <li data-id="element-392">
                <Link to="/reklamacije" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-393">
                  {lang === 'en' ? 'Returns & Refunds' : lang === 'ru' ? 'Возврат' : 'Reklamacije i povraćaj'}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-dark-border pt-6 text-center" data-id="element-394">
          <p className="text-gray-500 text-sm" data-id="element-395">
            © {new Date().getFullYear()} DTECH ATLAS DOO. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>;
}